// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reglements.css */
.cb-row-annule td {
    opacity: 0.45;
    text-decoration: line-through;
}

.cb-row-annule:hover td {
    opacity: 0.55;
}

/* Séparateur solide entre chaque bloc RT (sans enfants dépliés) */
.cb-row-rt > td {
    border-bottom: 3px solid #1a6b3c !important;
}

/* RT avec enfants : la bordure est portée par le bloc enfants (cf. .cb-expanded-children) */
.cb-row-rt-expanded > td {
    border-bottom: none !important;
}

.cb-expanded-children {
    border-bottom: 3px solid #1a6b3c !important;
    padding-bottom: 12px !important;
    margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/reglement.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA,kEAAkE;AAClE;IACI,2CAA2C;AAC/C;;AAEA,4FAA4F;AAC5F;IACI,8BAA8B;AAClC;;AAEA;IACI,2CAA2C;IAC3C,+BAA+B;IAC/B,2BAA2B;AAC/B","sourcesContent":["/* reglements.css */\n.cb-row-annule td {\n    opacity: 0.45;\n    text-decoration: line-through;\n}\n\n.cb-row-annule:hover td {\n    opacity: 0.55;\n}\n\n/* Séparateur solide entre chaque bloc RT (sans enfants dépliés) */\n.cb-row-rt > td {\n    border-bottom: 3px solid #1a6b3c !important;\n}\n\n/* RT avec enfants : la bordure est portée par le bloc enfants (cf. .cb-expanded-children) */\n.cb-row-rt-expanded > td {\n    border-bottom: none !important;\n}\n\n.cb-expanded-children {\n    border-bottom: 3px solid #1a6b3c !important;\n    padding-bottom: 12px !important;\n    margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
